<template>
<div>
  <br/>
  <b-row>
    <b-button class="mb-3" size="sm" @click="download();">Download for Excel</b-button>
  </b-row>
  
  <table class="table table-striped">
    <thead>
      <tr>
        <th>Group</th>
        <th>Total Responses</th>
        <th>Score</th>
        <th>Elements</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in rows" :key="item.dimension" class='c'>
        <td class="text-left align-top">
        {{ item.dimension }}
        </td>
        <td class="text-right align-top">
        {{ item.responses }}
        </td>
        <td class="text-right align-top">
        {{ (item.score || 0).toFixed(2) }}
        </td>
        <td class="text-left align-top">
          <b-btn @click="elementShowState[item.dimension] = !elementShowState[item.dimension]"
                  :class="elementShowState[item.dimension] ? null : 'collapsed'"
                  :aria-controls="item.dimension.replace('/[^a-zA-Z0-9]/g')"
                  :aria-expanded="elementShowState[item.dimension] ? 'true' : 'false'"
                  v-if="item.dimension !== 'Total'">Show/Hide</b-btn>
          <b-collapse :id="item.dimension.replace('/[^a-zA-Z0-9]/g')" class="mt-2" v-model="elementShowState[item.dimension]">
          <b-card>
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Element</th>
                <th>Responses</th>
                <th>Average</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="element in item.elements" v-bind:key="element.name" class='c'>
                <td>{{element.name}}</td>
                <td>{{element.responses}}</td>
                <td>{{element.average.toFixed(2)}}</td>
              </tr>
            </tbody>
          </table>
          </b-card>
          </b-collapse>
        </td>
      </tr>
    </tbody>
  </table>
</div>
</template>
<script>

import { getDimensionElementTotals, getOverallScore } from '@/services/analysis';
import * as XLSX from 'xlsx';
import * as _ from 'lodash';

export default {
    name: 'ScoreSummary',
    // properties you can pass to this component
    props: ['chartData'],
    components: {},
    // this is reactive data and will be updated in the view
    watch: {
      chartData: {
        handler(newData) {
          if (newData) this.draw();
        }
      }
    },
    data: function () {
        return {
            rows: [],
            elementShowState: {},
            displayType: 'full'
        };
    },
    created: function () {
      this.draw();
    },
    methods: {
      download() {
        const workbook = XLSX.utils.book_new();
        const content = this.rows.map(row => [row.dimension, row.responses, row.score.toFixed(2)]);
        content.unshift(['Group', 'Total Responses', 'Group Score']);
        XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(content), 'Group Data');
        const url = window.URL.createObjectURL(new Blob([XLSX.write(workbook, { type: 'array' })]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'group_data.xlsx') // have to specify a filename here
        document.body.appendChild(link)
        this.downloading = false;
        link.click()
      },
      draw() {
        const runningTotals = getDimensionElementTotals(this.chartData);
        this.rows = [];
        this.elementShowState = [];
        Object.keys(runningTotals).forEach((dimension) => {
          const runningTotal = runningTotals[dimension];
          if (dimension === 'totals') dimension = 'Total';
          const thisRow = {
            dimension,
            elements: [],
            responses: 0,
            score: 0
          };

          Object.keys(runningTotal.elementScores).forEach(elementScoreKey => {
            const elementScore = runningTotal.elementScores[elementScoreKey];
            thisRow.responses = Math.max(thisRow.responses, elementScore.responses)
            const thisElement = {
              name: elementScoreKey,
              responses: elementScore.responses,
              average: (elementScore.cumulativeScore / elementScore.responses)
            };
            thisRow.elements.push(thisElement);
          });
          thisRow.score = getOverallScore(_.values(runningTotal.elementScores));
          this.rows.push(thisRow);
        });
      }
    }
}
</script>




/* 
{
    "results":[
        {
        "id":1,
        "survey_monkey_id":157598244,
        "programme_id":1,
        "customer_id":1,
        "date_created":"2018-09-09T08:40:21.000Z",
        "survey_monkey_name":"Rachels Test Survey",
        "customer":{
            "id":1,
            "name":
            "Company-X"
            },
        "programme":{
            "id":1,
            "name":
            "Health Check"
            }
        }
    ],
    "pagination":{
        "totalRecords":1,
        "totalPages":1,
        "page":1,
        "pageSize":1
    }
}
*/


// WEBPACK FOOTER //
// src/components/ScoreSummary.vue